import type {ResourceChangeRealtimeHandler} from "../../../shared/realtime/resource-change-realtime.types";
import type {output} from "zod";

import {SupplierFunctionRealtimeChange} from "@project/sdk/realtime";

import {supplierFunctionKeys} from "../supplierFunction-keys";

type SupplierFunctionRealtimeChangeEvent = output<typeof SupplierFunctionRealtimeChange>;

export const supplierFunctionsRealtimeHandler: ResourceChangeRealtimeHandler<SupplierFunctionRealtimeChangeEvent> =
  {
    resource: "engineering.supplier-functions",
    queryKey: supplierFunctionKeys.all,
    eventSchema: SupplierFunctionRealtimeChange,
    async handleEvent(event, queryClient) {
      if (event.change === "CREATED") {
        await queryClient.invalidateQueries({queryKey: supplierFunctionKeys.lists()});

        return;
      }

      await queryClient.invalidateQueries({queryKey: supplierFunctionKeys.all});
    },
  };
